<template>
	<div class="terminal" >
		<el-breadcrumb separator="/" class="crumbs">
<!--			<el-breadcrumb-item :to="{ path: '/Menu' }">产品列表 ( {{ form.sval }} )</el-breadcrumb-item>-->
			<!-- <el-breadcrumb-item :to="{ path: '/Submenu/id=:"'+this.form.productId+'",token=:"'+this.form.token+'"' }">终端列表</el-breadcrumb-item> -->
			<el-breadcrumb-item :to="{ path: '/Submenu' }">终端列表( {{form.Tval}} )</el-breadcrumb-item>
			<el-breadcrumb-item >参数配置</el-breadcrumb-item>
		</el-breadcrumb>

		<el-tabs type="border-card" @tab-click="showTab">
			<!-- 1 -->
			<el-tab-pane label="参数分组" >
				  <div v-if="isShowTab == '0'">
				<div class="header"   >
					<el-button type="primary" size="small" @click="GroupEditAdd()">添加</el-button>
					<el-button type="primary" size="small" @click="dialogVisible1()" style="margin-left: 10px;">批量删除</el-button>
          <el-button type="primary" size="small" @click="copyGroup()" style="margin-left: 10px;">复制分组</el-button>
          <el-input
            class="search"
            size="small"
            placeholder="名称搜索"
            icon="el-icon-eleme"
            v-model="form.querySertitleName"
            @keyup.enter.native="querygroup" :on-icon-click="querygroup"
            width="100"
            style="margin-left: 10px;"
          ></el-input>
          <el-button type="primary" size="small" @click="querygroup()" style="margin-left: 10px;">搜索</el-button>

					<el-dialog
					  :visible.sync="dialogVisible"
					  width="30%"
					  :close-on-click-modal="false"
					 >
					  <span v-if = 'form.ids == 0'>请选择数据</span>
					  <p style="margin: 0px;height: 40px; line-height: 44px;" v-if = "form.ids != 0">
						  <i class="el-icon-delete-solid" style="font-size: 40px; color:#409EFF;float: left;"></i>
						  <span style="float: left;">确定删除吗？</span>
					  </p>
					  <span slot="footer" class="dialog-footer">
					    <el-button @click="dialogVisible = false"  size="small">取 消</el-button>
					    <el-button type="primary" @click="delgroup()"  size="small">确 定</el-button>
					  </span>
					</el-dialog>

					<!-- 分页 -->
					 <el-pagination
						class="paging"
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page.sync="form.pageNo"
						:page-size="form.pageSize"
						layout="total, prev, pager, next"
						:pager-count="7"
						:total="form.totalCount">
					  </el-pagination>
				</div>
			<div :style="{height:tableHeight - 70 +'px'}">
				<el-table
				:maxHeight="tableHeight - 70 + 'px'"
				 size="small"
				ref="multipleTable"
				:data="form.Groupinglist"
				tooltip-effect="dark"
				border
				@selection-change="handleSelectionChange = arguments[0]"
				:row-class-name="tableRowClassName"

				>
					<el-table-column type="selection" width="40" align="center"></el-table-column>
					<el-table-column label="名称">
						<template slot-scope="scope">
							{{ scope.row.name }}
						</template>
					</el-table-column>
					<el-table-column prop="npsKey" label="Key"></el-table-column>
					<el-table-column prop="groupDesc" label="描述"></el-table-column>
					<el-table-column label="时间"  width="120" align="center">
						<template slot-scope="scope">
							{{formatCreateDate(scope.row.createDate)}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="520" align="center">
						<template scope="scope">
							<el-button type="primary" size="small" @click="GroupEditAdd(scope.row)">编辑</el-button>
							<el-button type="primary" size="small" @click="querygroupparams(scope.row.id)" v-if="scope.row.groupType == 1">设置参数</el-button>   <!--  -->
							<el-button type="primary" size="small" @click="setcommongroup(scope.row)" v-if="scope.row.groupType == 1">设为共有分组</el-button>
							<el-button  type="primary" v-if="scope.row.enable == 0"   size="small"  @click="Enable(scope.row,1)">启用</el-button>
							<el-button type="danger" v-else size="small" @click="Enable(scope.row,0)">禁用</el-button>

							<el-button  type="danger" v-if="scope.row.defaultreturn == 1"   size="small"  @click="cancelEnable(scope.row,2)">取消默认</el-button>

							<el-button type="primary" v-else size="small" @click="cancelEnable(scope.row,1)">设为默认</el-button>


                            <el-button type="primary" size="small" v-if="scope.row.groupType == 1" @click="exportData(scope.row.id)">导出</el-button>
						</template>
					</el-table-column>
				</el-table>
				</div>
				</div>
			</el-tab-pane>

			<!-- 设为共有分组 -->
			<template>
			  <el-dialog title="提示" :visible.sync="dialogFormVisibleGrouping" width="30%" :close-on-click-modal="false">
				  <span style="color: #F56C6C;font-size: 16px;">公共分组 ({{ repeatName }}) 已存在</span>
			    <el-dialog
			      width="30%"
			      :visible.sync="innerVisible"
			      append-to-body>

				  <el-form ref="form" :model="form" label-width="80px" size="small">
				  	<el-form-item label="名称"><el-input v-model="form.GroupingName"></el-input></el-form-item>
				  	<el-form-item label="key"><el-input v-model="form.GroupingKey"></el-input></el-form-item>
				  </el-form>
				  <div slot="footer" class="dialog-footer">
				  	<el-button @click="innerVisible = false" size="small">取 消</el-button>
				  	<el-button type="primary" @click="save_publicGrouping()" size="small">确 定</el-button>
				  </div>

			    </el-dialog>
			    <div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="editValue()" size="small">重命名</el-button>
					<el-button type="primary" @click="cover()" size="small">覆盖</el-button>
			      <el-button @click="dialogFormVisibleGrouping = false" size="small">取 消</el-button>

			    </div>
			  </el-dialog>
			</template>
			<!-- 参数分组编辑 -->
			<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="40%" :close-on-click-modal="false">
				<el-form :model="form">
					<el-form-item label="名称" :label-width="formLabelWidth"  size="small"><el-input v-model="form.editlyAddedName" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="Key" :label-width="formLabelWidth"  size="small"><el-input v-model="form.editlyAddedKey" autocomplete="off"></el-input></el-form-item>
                    <el-form-item label="描述" :label-width="formLabelWidth">
				       <el-input type="textarea" v-model="form.groupDesc"></el-input>
				    </el-form-item>
					<el-form-item label="参数" :label-width="formLabelWidth" v-if="form.groupType == 2">
					   <el-input type="textarea" :rows="8" v-model="form.groupValue"></el-input>
					</el-form-item>
					<el-form-item label="传统方式" :label-width="formLabelWidth" v-if="!checkboxShow">
					   <el-checkbox v-model="checked"  @change="typeConversion"></el-checkbox>
					   <span style="color: #f00;" >(不推荐)</span>
					</el-form-item>

				</el-form>

				<div id="codeEditor" style="display: none"></div>

				<pre style="width: 500px; height: 50px;">
					{{errormsg}}
				</pre>

				<div slot="footer" class="dialog-footer">
					<el-button type="primary" v-if="checkParamShow" @click="check_param()" size="small">校验</el-button>
					<el-button @click="cancelEdit(form)" size="small">取 消</el-button>
					<el-button type="primary" @click="save_Grouping()" size="small">确 定</el-button>
				</div>
			</el-dialog>

      <!-- 复制分组 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogCopyGroupVisible" width="40%" :close-on-click-modal="false">
        <el-form :model="copyForm">
          <el-form-item label="分组前缀:" :label-width="formLabelWidth"  size="small"><el-input v-model="copyForm.prefix" autocomplete="off"></el-input></el-form-item>
        </el-form>
        <div :style="{height:tableHeight - 150 +'px'}">
          <el-table
            ref="copyGroupTable"
            :maxHeight="tableHeight - 150 + 'px'"
            :data="copyGroupData"
            highlight-current-row
            border
            @current-change="handleCopyGroupSelect"
            style="width: 100%">
            <el-table-column
              type="index"
              width="50">
            </el-table-column>
            <el-table-column
              property="name"
              label="终端名称">
            </el-table-column>
            <el-table-column
              label="类型">
              <template scope="scope">
                <div v-if="scope.row.type == submenu1.PHONE.code">手机</div>
                <div v-else-if="scope.row.type == submenu1.PC.code">PC</div>
                <div v-else-if="scope.row.type == submenu1.BOX.code">盒子</div>
                <div v-else-if="scope.row.type == submenu1.OTHER.code">其他</div>
              </template>
            </el-table-column>

            <el-table-column label="时间" width="150" align="center">
              <template slot-scope="scope">
                {{formatCreateDate(scope.row.createDate)}}
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelCopyGroup(form)" size="small">取 消</el-button>
          <el-button type="primary" @click="copy_Grouping()" size="small">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 设置参数 -->
			<el-dialog title="设置参数" :visible.sync="dialogTableVisible" fullscreen  >
				<el-button type="primary" size="small" :disabled="disabledSelectBt" @click="saveparam()" style="margin-bottom: 10px;">添加一个</el-button>
				<el-button type="primary" size="small" :disabled="disabledSelectBt" @click="querycommongroup()">选共有分组</el-button>
        <el-button type="primary" size="small" :disabled="disabledSelectBt" @click="importMoreData()">导入多个</el-button>
				<el-button type="primary" size="small" v-if="disabledSelectBt1"  @click="saveBatchCommonGroupHandler()">保存</el-button>

				<!-- 分页 -->
			  <div :style="{height:tableHeight - 30 +'px'}">
			  <el-table :data="formGrouping.params" border :maxHeight="tableHeight - 30 + 'px'"  size="small">
				<el-table-column property="name" label="名称" >
					<template slot-scope="scope">
						<div  :class="{topContent:scope.row.cssType === 1,redrecord:scope.row.cssType === 2}">
						{{scope.row.name}}
						</div>
					</template>
				</el-table-column>
				<el-table-column property="" label="来源" align="center" width="160">
					<template slot-scope="scope">
						<span v-if="scope.row.referencesId">
						公共组:{{ scope.row.commGroupName }}
						</span>
					</template>
				</el-table-column>
				<el-table-column property="paramInfo" label="参数值" width="250"></el-table-column>
				<el-table-column property="paramDesc" label="描述" width="150"></el-table-column>
				<el-table-column label="时间" width="150" align="center">
					<template slot-scope="scope">
						{{formatCreateDate(scope.row.createDate)}}
					</template>
				</el-table-column>

					<el-table-column label="类型" width="100" align="center">
						 <template scope="scope">
						  <div v-if="scope.row.type == type.STRING.code">string</div>
						  <div v-if="scope.row.type == type.INT.code">int</div>
						  <div v-if="scope.row.type == type.BOOLEAN.code">boolean</div>
						  <div v-if="scope.row.type == type.ARRAY.code">array</div>
						  <div v-if="scope.row.type == type.OBJECT.code">object</div>
						</template>
				</el-table-column>
				<el-table-column label="操作" width="120" align="center">
					<template slot-scope="scope">
						<el-button type="primary"  @click="saveparam(scope.row)" v-if = '!scope.row.cssType' style="margin-right: 10px;" size="small">编辑</el-button>
						<i class="el-icon-close" @click="delparam(scope.$index, scope.row)"></i>
					</template>
					</el-table-column>
			  </el-table>
			  </div>

			</el-dialog>

			<!--设置参数 添加 -->
			<el-dialog :title="dialogTitle1" :visible.sync="dialogFormVisible11" width="40%" :close-on-click-modal="false">
				<el-form ref="form" :model="form" label-width="80px">
					<el-form-item label="参数名称" size="small"><el-input v-model="formGrouping.name"></el-input></el-form-item>
					<!-- <el-form-item label="参数值" size="small"><el-input v-model="formGrouping.paramInfo"></el-input></el-form-item> -->

					<el-form-item label="参数值" style="width: 100%;">
					  <el-input type="textarea" v-model="formGrouping.paramInfo"></el-input>
					</el-form-item>

					<el-form-item label="类型" size="small">
						<el-select v-model="formGrouping.type" placeholder="请选择" style="width: 100%;">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="描述" style="width: 100%;">
					  <el-input type="textarea" v-model="formGrouping.paramDesc"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible11 = false" size="small">取 消</el-button>
					<el-button type="primary" @click="save_parameters()" size="small">确 定</el-button>
				</div>
			</el-dialog>
			<!--设置参数   选共有分组-->
			<el-dialog title="选共有分组" :visible.sync="dialogTableVisible1" top="0" :close-on-click-modal="false">
				<el-input
					class="search"
					size="small"
					placeholder="名称搜索"
					icon="el-icon-eleme"
					v-model="form.querySertitleName"
					@keyup.enter.native="querycommongroup" :on-icon-click="querycommongroup"
					width="120"
				></el-input>
				<el-input
					class="search"
					size="small"
					placeholder="Appkey搜索"
					icon="el-icon-eleme"
					v-model="form.querySertitleAppkey"
					@keyup.enter.native="querycommongroup" :on-icon-click="querycommongroup"
					width="120"
				></el-input>

				<el-button type="primary" size="small" @click="querycommongroup">搜索</el-button>
				<div :style="{height:tableHeight - 150 +'px'}">
				<el-table
				    ref="singleTable"
					:maxHeight="tableHeight - 150 + 'px'"
				    :data="formGrouping.list"
				    highlight-current-row
					border
					@current-change="handleCurrent"
				    style="width: 100%">
				    <el-table-column
				      type="index"
				      width="50">
				    </el-table-column>
				    <el-table-column
				      property="name"
				      label="名称">
				    </el-table-column>
				    <el-table-column
				      property="name"
				      label="AppKey">
				    </el-table-column>

					<el-table-column label="时间" width="150" align="center">
						<template slot-scope="scope">
							{{formatCreateDate(scope.row.createDate)}}
						</template>
					</el-table-column>

				  </el-table>
                  </div>
			  <el-button type="primary" size="small"  @click="save_SelectCommonGroup(2)" style="text-align: right;margin-top: 20px;position: relative;right: 0;bottom: 0;">复制</el-button>
			  <el-button type="primary" size="small"  @click="save_SelectCommonGroup(1)" style="text-align: right;margin-top: 20px;position: relative;right: 0;bottom: 0;">引用</el-button>
			</el-dialog>

      <!--设置参数   导入多个参数-->
      <el-dialog title="参数输入" :visible.sync="dialogImportMoreVisible" top="0" :close-on-click-modal="false">
        <el-input
          type="textarea"
          icon="el-icon-eleme"
          v-model="importJsonStr"
          width="120"
          rows = 20
        ></el-input>

        <el-button type="primary" size="small"  @click="save_ImportMoreParam()" style="text-align: right;margin-top: 20px;position: relative;right: 0;bottom: 0;">确认</el-button>
      </el-dialog>

      <!-- 2 -->
			<el-tab-pane label="参数" >
                <Parameter v-bind:terminalId="form.terminalId"  v-if="isShowTab  == '1'"></Parameter>
			</el-tab-pane>
			<!-- 3 -->
			<el-tab-pane label="串号分组"  >
                <SerialNumber v-bind:terminalId="form.terminalId" v-if="isShowTab == '2'"></SerialNumber>
			</el-tab-pane>
			<!-- 4 -->
			<el-tab-pane label="IPv4分组">
                <IpComponent v-bind:terminalId="form.terminalId" v-if="isShowTab == '3'"></IpComponent>
			</el-tab-pane>
      <el-tab-pane label="IPv6分组">
        <Ipv6Component v-bind:terminalId="form.terminalId" v-if="isShowTab == '4'"></Ipv6Component>
      </el-tab-pane>
			<!-- 5 -->
			<el-tab-pane label="Nube分组">
                <NubeComponent v-bind:terminalId="form.terminalId" v-if="isShowTab == '5'"></NubeComponent>
			</el-tab-pane>
			<!-- 6 -->
      <el-tab-pane label="Appkey分组"  >
        <AppKeyComponent v-bind:terminalId="form.terminalId" v-if="isShowTab == '6'"></AppKeyComponent>
      </el-tab-pane>
      <!-- 7 -->
			<el-tab-pane label="默认分组">
			    <TheGefaultGroup v-bind:terminalId="form.terminalId" v-if="isShowTab == '7'"></TheGefaultGroup>
			</el-tab-pane>


		</el-tabs>
	</div>
</template>

<script>

  import constants from '@/js/constants.js'
	import api from '@/api/menu/'
	import { mapState } from 'vuex';
	// 启用禁用 状态
	const state = {
	  ENABLE: { code: 0, label: '启用'},
	  PROHIBIT: { code: 1, label: '禁用' },
	};


	//添加一个的类型
	const type = constants.type;
  const submenu1 = constants.submenu1;
	import Parameter from './parameter'//参数
	import SerialNumber from './serialNumber'  //串号
	import IpComponent from './ipComponent'  //IPv4
	import Ipv6Component from './ipv6Component'  //IPv6
  import AppKeyComponent from './appkeyComponent'  //appkey
	import NubeComponent from './nubeComponent'  //IP
	import TheGefaultGroup from './theGefaultGroup'  //IP
export default {
	computed: {
		...mapState('main', ['tableHeight'])
	},
	data() {
		return {
			dialogVisible: false,
			state,
			type,
			editId:'',
			formName:'',
			checked: false,
			checkboxShow:true,
			checkParamShow:false,
			isShowTab:"0",//切换菜单
			disabledSelectBt :false,
			disabledSelectBt1 :false,
			repeatName:'',
			options: constants.options,
			dialogFormVisibleGrouping:false,
			dialogTableVisible: false,
			dialogTableVisible1: false,
      dialogImportMoreVisible: false,
			dialogFormVisible11: false,
			dialogFormVisible: false,
      dialogCopyGroupVisible: false,
			handleSelectionChange:[],//获取删除的id和token 分组
			selectGroupIdvalue:'',
			dialogTitle:'',//添加 编辑
			dialogTitle1:'',//添加 编辑
			innerVisible: false,
			errormsg:'',
			publicId:'',//引用
      copyForm:{
			  devModelId: "",
			  prefix: ""
      },
      submenu1,
      copyGroupData: [],
      importJsonStr:'',
			form: { //分组
        Tval:"",
				sval:'',
				name: '',
				desc:'',
				groupType:"1",
				terminalId:'',//所属终端
				Groupinglist:[], //列表
				groupDesc:'',//描述
				groupValue:'',//参数
				editlyAddedName:'',//名称
				editlyAddedKey:'',  //key
				enable:0, //1启用 禁用0
				cancelEnable:1,
				pageSize:15,
				pageNo: 1,//当前页码
				totalPage: 0,//总页数
				//paginationShow: true,//是否显示分页
				totalCount: 0,//总条数
				querySertitleName:'',
				querySertitleAppkey:"",
				id:'',
				token:'',
				ids:[] ,//选中
				GroupingName:'',
				GroupingKey:'',
				SubordinateId : ''
			},
			//11.13 设置参数>对分组添加参数
			formGrouping:{
				groupId: '',//分组id
				typeArray: 1,//单个1 批量2
				params:[],// 初始化列表
				name: '',//参数的名称
				paramInfo : '',//参数的值
				type: 1,// 类型  1:int 2:string 3:boolean
				paramDesc : '',//参数描述
				list:[], // 选共有分组列表
				id:'',//单选id值
			},
			formLabelWidth: '120px',
		};
	},
	methods: {
		typeConversion(){
			if(this.checked){
				this.form.groupType = '2';
				this.checkParamShow = true;
			}else{
				this.form.groupType = '1';
				this.checkParamShow = false;
			}
		},
		check_param(){
		if(this.form.groupValue == ''){
		retrun;
		}
		var codeEditor = document.getElementById("codeEditor");
		//初始化编辑器模式
		var codeOptions = {
		    mode: 'code',
		    modes: ['code'],
		    onError: function(err) {
			alert(err.toString());
		    }
		};

		//初始化编辑器内容
		var codeEditor = new this.$jsoneditor(codeEditor, codeOptions);
		codeEditor.setText(this.form.groupValue);

		try {
                var codeContent = codeEditor.get();
               this.errormsg = '';
            } catch(e) {
		console.log(e.message);
                this.errormsg = e.message;
		alert(e.message);
            }

		},
		dialogVisible1(){
		   this.dialogVisible = true;
		   this.form.ids = this.handleSelectionChange.map(item => item.id);
		},
		//切换菜单
		showTab(tab){
			console.log(tab)
		  if(tab.index =="0"){
		  this.isShowTab = '0';
		  this.querygroup();
		  }else  if(tab.index =="1"){
		    this.isShowTab = '1';
		  }else  if(tab.index =="2"){
		    this.isShowTab = '2';
		  }else  if(tab.index =="3"){
			this.isShowTab = '3';
		  }else  if(tab.index =="4"){
			this.isShowTab = '4';
		  }else  if(tab.index =="5"){
			this.isShowTab = '5';
		  }else  if(tab.index =="6"){
        this.isShowTab = '6';
      }else  if(tab.index =="7"){
        this.isShowTab = '7';
      }
		},
		// 11.11设置分组为公共组
		setcommongroup(src){
			this.repeatName = src.npsKey;
			this.form.SubordinateId = src.id;
			var data = {
			  'name':'',
			  'key':'',
			  'token':this.form.token,
			  'groupId':src.id,
			  'override':''
			};
			api.setcommongroup(data)
				.then(res => {
					if(res.data.code == 0){
						successMsg({
							message: '保存成功'
						})
					}else{
						if(res.data.code == 1104){
							this.dialogFormVisibleGrouping = true;
						}
						errorMsg({
							   message: res.data.msg
						})
					}
				})
		},
		// 覆盖 保存 公共分组
		save_publicGrouping(){
			// 返回 1104
			var data = {
			  'name':this.form.GroupingName,
			  'key':this.form.GroupingKey,
			  'token':this.form.token,
			  'groupId':this.form.SubordinateId,
			  'override':""
			};
			this.innerVisible = false;
			api.setcommongroup(data)
				.then(res => {
					if(res.data.code == 0){
						successMsg({
							message: '保存成功'
						})
					this.dialogFormVisibleGrouping = false;
					}else{
						errorMsg({
							   message: res.data.msg
						})
					}
				})
		},
		// 编辑公共分组
		editValue(){
			this.innerVisible = true;
		},
	   // 覆盖
		cover(){
			// 返回 1104
			var data = {
			  'name':'',
			  'key':'',
			  'token':this.form.token,
			  'groupId':this.form.SubordinateId,
			  'override':1
			};

			api.setcommongroup(data)
				.then(res => {
					if(res.data.code == 0){
					successMsg({
						message: '保存成功'
					})

				this.dialogFormVisibleGrouping = false;
					}else{
						errorMsg({
							message: res.data.msg
						})
					}
				})
		},
		// 选共有分组 保存
		save_SelectCommonGroup(val){
			if(val == 1){//引用
			this.publicId = 1;
			}else if(val == 2){
			this.publicId = 2;
			}

			var data = {
			  'commonGroupId':this.formGrouping.id,
			  'token':this.form.token,
			};
			var _this = this;
			api.querycommongroupparams(data)
				.then(res => {
					if(res.data.code == 0){
						 this.disabledSelectBt = true;
						 this.disabledSelectBt1 = true;
						 var _commonParamTable = _this.formGrouping.params;

						  for(let i=0;i<res.data.data.length;i++){
							res.data.data[i].cssType = 1;
							res.data.data[i].commGroupName = this.formName;
							res.data.data[i].referencesId = res.data.data[i].groupId;
						  }
						  for(let i=0;i<res.data.data.length;i++){
							var obj = res.data.data[i];
							for(let j=0;j<_commonParamTable.length;j++){
							  if(obj.name == _this.formGrouping.params[j].name){
								res.data.data[i].cssType = 2;
							  }
							}
						  }

						  for(let i=0;i<res.data.data.length;i++){
							_this.formGrouping.params.push(res.data.data[i]);
						  }
						  console.log(this.formGrouping.params);
						  this.dialogTableVisible1 = false;
					}else{
						errorMsg({
							   message: res.data.msg
						})
						console.log(res.data.msg);
					}
				})
				this.dialogTableVisible1 = false;
		},
    save_ImportMoreParam(){

      if(this.importJsonStr == '' || Array.isArray(this.importJsonStr)){
        warningMsg({
          message: "请输入正确JSON字符串"
        })
        retrun;
      }

      if (typeof this.importJsonStr == 'string') {
        try {
          var obj = JSON.parse(this.importJsonStr);
          if(Array.isArray(obj) ){
            warningMsg({
              message: "请输入正确JSON字符串"
            })
            retrun;
          }
          if(typeof obj == 'object' && obj ){
            var timestamp = parseInt(new Date().getTime()/1000);
            var arrayImportParam = [];
            for(var key in obj){
              let jsonStr = obj[key];
              if((typeof(jsonStr) == "object" && Object.prototype.toString.call(jsonStr).toLowerCase() == "[object object]" && !jsonStr.length)
              || Array.isArray(jsonStr)){
                jsonStr = JSON.stringify(obj[key]);
              }
              var objParam = {
                name:key,
                paramInfo:jsonStr,
                type:"1",
                paramDesc:"",
                cssType : 1,
                createDate:timestamp
              }
              arrayImportParam.push(objParam);
            }

            this.disabledSelectBt = true;
            this.disabledSelectBt1 = true;
            var _commonParamTable = this.formGrouping.params;

            for(let i=0;i<arrayImportParam.length;i++){
              var obj = arrayImportParam[i];
              for(let j=0;j<_commonParamTable.length;j++){
                if(obj.name == this.formGrouping.params[j].name){
                  arrayImportParam[i].cssType = 2;
                }
              }
            }

            for(let i=0;i<arrayImportParam.length;i++){
              this.formGrouping.params.push(arrayImportParam[i]);
            }

          }else{
            warningMsg({
              message: "请输入正确JSON字符串"
            })
            return false;
          }
        } catch(e) {
          warningMsg({
            message: "请输入正确JSON字符串"
          })
          return false;
        }
        this.dialogImportMoreVisible = false;
      }else{
        warningMsg({
          message: "请输入正确JSON字符串"
        })
      }

    },
		// 单选值
		handleCurrent(val){
			console.log(val)
			if(val){
				this.formGrouping.id = val.id;
				this.formName = val.name
			}

		},
    handleCopyGroupSelect( val ) {
      if(val){
        this.copyForm.devModelId = val.id;
      }
    },
    setCurrent(row) {
      this.$refs.copyGroupTable.setCurrentRow(row);
    },
		// 删除设置参数
		delparam(index, row){
			if(!row.cssType){
				var data = {
				  paramId:row.id,
				  token: this.form.token
				}
				api.editparamDeleteGrouId(data)
				  .then(res => {
					if(res.data.code == 0){
					}else{
					  errorMsg({message:res.data.msg})
					}
				  })
			}


			this.disabledSelectBt1 = true;
			this.formGrouping.params.splice(index,1);
			var name = row.name;
			for(let i=0;i<this.formGrouping.params.length;i++){
			  if(this.formGrouping.params[i].cssType
			    && this.formGrouping.params[i].name == name
			    && this.formGrouping.params[i].cssType == 2 ){
			    this.formGrouping.params[i].cssType = 1;
			  }
			}
		},
		// 保存
			saveBatchCommonGroupHandler(){
			  var paramTable = this.formGrouping.params;
			console.log(paramTable)

			  var paraArray = [];
			  for(let i=0;i<paramTable.length;i++){
			    if(paramTable[i].cssType == 2){
			      errorMsg({message:"冲突，请删除红色部分"})
			      return;
			    }else if(paramTable[i].cssType == 1){
					if(this.publicId == 1){  //引用
						var obj = {
						  "name":paramTable[i].name,
						  "paramInfo":paramTable[i].paramInfo,
						  "type":paramTable[i].type,
						  "paramDesc":paramTable[i].paramDesc,
						  "referencesId":paramTable[i].referencesId,
              "commid":paramTable[i].id
						}
					}else{
						var obj = {
						  "name":paramTable[i].name,
						  "paramInfo":paramTable[i].paramInfo,
						  "type":paramTable[i].type,
						  "paramDesc":paramTable[i].paramDesc,
						}
					}
					paraArray.push(obj);
					console.log(paraArray)
			  }else{

				  var obj = {
				    "name":paramTable[i].name,
				    "paramInfo":paramTable[i].paramInfo,
				    "type":paramTable[i].type,
				    "paramDesc":paramTable[i].paramDesc,
					  "referencesId":paramTable[i].referencesId,
            "commid":paramTable[i].commid
				  }

				  paraArray.push(obj);
				  console.log(paraArray)
			  }

			  }
			 var data = {
			   terminalId: this.form.terminalId,
			   groupId: this.selectGroupIdvalue,
			   token: this.form.token,
			   params: paraArray,
			   type:2,
			 }
			  api.saveparam( data )
			    .then(res => {
			      if(res.data.code == 0){
					 this.disabledSelectBt = false;
					 this.disabledSelectBt1 = false;
					 this.dialogTableVisible = false;
					 this.publicId == '';
					 // this.formGrouping.id = '';
			        successMsg({message:"保存成功"})
					this.queryCommonGroupParam(this.selectGroupIdvalue)
			      }else{
			        errorMsg({message:res.data.msg})
			      }
			    })
			},
			queryCommonGroupParam( groupId ){
			  var data = {
			    commonGroupId :groupId,
			    token: this.form.token
			  }

			  api.querycommongroupparams(data)
			    .then(res => {
			      if(res.data.code == 0){
			        this.formGrouping.params = res.data.data;
						  // console.log(this.commonParamTable)
			      }else{
			        errorMsg({message:res.data.msg})
			      }
			    })
			},
		// 时间格式
		formatCreateDate: function(row) {
		  let createDate = row;
		  return window.formatDate(createDate);
		},
    exportData(id){
      var data = {
        'groupId':id,
        'token':this.form.token,
      };
      api.exportData(data)
        .then(res => {
          this.downFunction('param.txt',JSON.stringify(res.data,null,"\t"));
        })
    },
    downFunction(name, data) {
      var urlObject = window.URL || window.webkitURL || window;
      var export_blob = new Blob([data]);
      var save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = name;
      this.fakeClick(save_link);
    },
    fakeClick(obj){
      var ev = document.createEvent("MouseEvents");
      ev.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      obj.dispatchEvent(ev);
    },
		// 11.10查询分组参数列表
		querygroupparams(id){
            this.disabledSelectBt = false;
            this.disabledSelectBt1 = false;
			this.selectGroupIdvalue = id;
			if(id){
			this.form.id = id;
			}
			var data = {
			  'groupId':this.form.id,
			  'token':this.form.token,
			};
			api.querygroupparams(data)
				.then(res => {
					if(res.data.code == 0){
						  this.formGrouping.params = res.data.data;
					}else{
						errorMsg({
							   message: res.data.msg
						})
						console.log(res.data.msg);
					}
				})
				this.dialogTableVisible = true;
		},
		// 11.13对分组添加参数
		saveparam(val){
			if(val){
				this.editId = 1;
				this.dialogFormVisible11 = true;
				this.dialogTitle1 = "编辑参数";
				this.formGrouping.type = this.options[0].value;
				this.formGrouping.groupId = val.groupId;//分组id
				this.formGrouping.id = val.id;//分组id
				this.formGrouping.name = val.name;//参数的名称
				this.formGrouping.paramInfo = val.paramInfo;//参数的值
				this.formGrouping.type = val.type;// 类型  1:int 2:string 3:boolean
				this.formGrouping.paramDesc = val.paramDesc;//参数描述
			}else{
				this.dialogFormVisible11 = true;
				this.dialogTitle1 = "添加参数";
				this.formGrouping.type = this.options[0].value;
				// this.formGrouping.groupId = '';//分组id
				this.formGrouping.name = '';//参数的名称
				this.formGrouping.paramInfo = '';//参数的值
				// this.formGrouping.type = 1;// 类型  1:int 2:string 3:boolean
				this.formGrouping.paramDesc = '';//参数描述
			}


		},
		// 添加一个保存
		save_parameters(){
			if(this.editId == 1){
				//编辑
				// alert(111)
				var data = {
					groupId: this.formGrouping.groupId,//分组id
					terminalId: this.form.terminalId,//所属终端
					// type: this.formGrouping.typeArray,//单个1 批量2
					type: this.formGrouping.type,// 类型  1:int 2:string 3:boolean
					token:this.form.token, //用户校验的token
					name: this.formGrouping.name,//参数的名称
					paramInfo : this.formGrouping.paramInfo,//参数的值
					paramDesc : this.formGrouping.paramDesc,//参数描述
					id : this.formGrouping.id
				 };
				// 编辑
				api.editparam(data)
					.then(res => {
						if(res.data.code == 0){
							 this.querygroupparams(this.selectGroupIdvalue);
							successMsg({
								   message: '保存成功'
							})
							// this.formGrouping.groupId = this.selectGroupIdvalue;//分组id
							// this.formGrouping.id = this.form.id;
							this.formGrouping.name = '';//参数的名称
							this.formGrouping.paramInfo = '';//参数的值
							this.formGrouping.type = 1;// 类型  1:int 2:string 3:boolean
							this.formGrouping.paramDesc = '';//参数描述
							this.dialogFormVisible11 = false;
							// this.disabledSelectBt1 = true;
							this.editId = '';
						}else{
								errorMsg({
									message: res.data.msg
								})

						}
					})
			}else{
        if(this.form.id == "" || this.formGrouping.name == "" ||
          this.formGrouping.paramInfo ==""){
          errorMsg({
            message: "请输入参数名称、参数值!"
          })
          return;
        }
				var data = {
						groupId: this.form.id,//分组id
						terminalId: this.form.terminalId,//所属终端
						type: this.formGrouping.typeArray,//单个1 批量2
						token:this.form.token, //用户校验的token
						params:[
							{
								name: this.formGrouping.name,//参数的名称
								paramInfo : this.formGrouping.paramInfo,//参数的值
								type: this.formGrouping.type,// 类型  1:int 2:string 3:boolean
								paramDesc : this.formGrouping.paramDesc,//参数描述
							}
						]
					};

				api.saveparam(data)
					.then(res => {
						if(res.data.code == 0){
							console.log(res);
							this.querygroupparams(this.selectGroupIdvalue);
							successMsg({
								   message: '保存成功'
							})
							// this.disabledSelectBt1 = true;
							// this.formGrouping.groupId = '';//分组id
							this.formGrouping.name = '';//参数的名称
							this.formGrouping.paramInfo = '';//参数的值
							this.formGrouping.type = 1;// 类型  1:int 2:string 3:boolean
							this.formGrouping.paramDesc = '';//参数描述
							this.dialogFormVisible11 = false;
						}else{
								errorMsg({
									   message: res.data.msg
								})
								this.dialogFormVisible11 = true;
						}
					})
			}


		},
		// 11.22查询公共分组信息
		querycommongroup(){
			var data = {
			  'name':this.form.querySertitleName,
			  'key':this.form.querySertitleAppkey,
			  'pageNo':1,
			  'pageSize':15,
			  'token':this.form.token,
			};
			api.querycommongroup(data)
				.then(res => {
					if(res.data.code == 0){
						this.formGrouping.list = res.data.data.list;
						console.log(res);
					}else{
						errorMsg({
							   message: res.data.msg
						})
						console.log(res.data.msg);
					}
				})
				this.dialogTableVisible1 = true;
		},
    importMoreData(){
      this.importJsonStr = '';
      this.dialogImportMoreVisible = true;
    },
		// 启用 禁用分组
		Enable(src,enable){
			var data = {
			  'groupId':src.id,
			  'token':this.form.token,
			  'enable':enable
			};
			api.setgroupstatus(data)
				.then(res => {
					if(res.data.code == 0){
						this.querygroup();
					}else{
						errorMsg({
							   message: res.data.msg
						})
					}
				})
		},
		// 取消设为 分组
		cancelEnable(src,cancelEnable){
			var data = {
			  'groupId':src.id,
			  'token':this.form.token,
			  'defaultreturn':cancelEnable
			};
			api.setgroupDefaultReturn(data)
				.then(res => {
					if(res.data.code == 0){
						this.querygroup();
					}else{
						errorMsg({
							   message: res.data.msg
						})
					}
				})
		},
		 tableRowClassName({row, rowIndex}) {
		        if (row.enable == 0) {
		          return 'warning-row';
		        }
		        return '';
		      },
		// 分组删除
		delgroup(){
			this.dialogVisible = false;
			var ids = [];
			if(this.form.ids.length == 0){
			    ids = this.form.ids;
			}else{
				ids = this.form.ids;

			var data = {
			  'ids':this.form.ids,
			  'token':this.form.token
			};
		 api.delgroup(data)
			.then(res => {
				if(res.data.code == 0){
					if(this.form.ids.length == 0){
					}else{
						this.querygroup();
						successMsg({
							   message: '删除成功'
						})
					}
				}else{
					errorMsg({
						   message: res.data.msg
					})
				    console.log(res.data.msg);
				}
			})
			}
		},
		//改变每页显示数量时调用  分组
		  handleSizeChange(val) {
		  this.$nextTick(() =>
		    this.querygroup(),
		  )
		},
		//点击下一页和点击页码时执行   分组
		handleCurrentChange(val) {
		  this.querygroup();
		},
		// 分组   保存
		save_Grouping(){
			var id = '';
			if(this.form.id){
				id = this.form.id;
			}else{
				id = '';
			}
			 var data = {
			  'id':id,
			  'groupDesc':this.form.groupDesc,
			  'groupType':this.form.groupType,
			  'groupValue':this.form.groupValue,
			  'name':this.form.editlyAddedName,
			  'token':this.form.token,
			  'enable':this.form.enable,
			  'terminalId':this.form.terminalId,
			  'key':this.form.editlyAddedKey,
			};

		 api.editgroup(data)
			.then(res => {
				if(res.data.code == 0){
					this.checked = false;
					this.form.editlyAddedName = '';
					this.form.groupDesc = '';
					this.form.groupValue = '';
					this.form.id = '';
					this.form.editlyAddedKey = '';
					this.form.enable = 0;
					this.form.cancelEnable = 1;
					this.form.groupType = '1'
					this.querygroup();
					console.log(res.data.msg);
					this.dialogFormVisible = false;
				}else{
				    console.log(res.data.msg);
						errorMsg({
							   message: res.data.msg
						})
						this.dialogFormVisible = true;
				}
			})
		},
    initCopyGroupData(){
      this.copyGroupData = [];
      var data = {
        'productId':this.$route.params.pid,
        'pageNo':this.form.pageNo,
        'pageSize':10000000,
        'token':this.form.token,
      };
      var _this = this;
      api.queryterminal(data)
        .then(res => {
          if(res.data.code == 0){
            this.copyGroupData = res.data.data.terminalList;

          }else{
            errorMsg({
              message: res.data.msg
            })
          }
        })

    },
    copy_Grouping(){
      this.dialogCopyGroupVisible = false;
        var data = {
          'ids':this.form.ids,
          'token':this.form.token,
          'prefix': this.copyForm.prefix,
          'devModelId': this.copyForm.devModelId
        };
        api.copygroup(data)
          .then(res => {
            if(res.data.code == 0){
              this.querygroup();
              successMsg({
                message: '复制成功'
              })
            }else{
              errorMsg({
                message: res.data.msg
              })
              console.log(res.data.msg);
            }
          })

    },
		// 取消 分组编辑
		cancelEdit(formName){
             this.form.editlyAddedName = '';
             this.form.groupDesc = '';
			 this.form.groupValue = '';
             this.form.id = '';
             this.form.editlyAddedKey = '';
             this.form.enable = 0;
			 this.form.cancelEnable = 1;
		     this.dialogFormVisible = false;

		},
    cancelCopyGroup(){
      this.dialogCopyGroupVisible = false;
    },
		// 11.8新增分组  添加 编辑
		 GroupEditAdd(parameter){
		 		this.errormsg = '';
				if(parameter){
					if(parameter.groupType == 1){
						this.form.groupType = parameter.groupType;
					}
					if(parameter.groupType == 2){
						this.form.groupType = parameter.groupType;
					}

				this.dialogTitle = "编辑分组";
				this.dialogFormVisible = true;
				this.form.groupDesc = parameter.groupDesc;
				this.form.groupValue = parameter.groupValue;
				this.form.editlyAddedName = parameter.name;
				this.form.terminalId = parameter.terminalId;
				this.form.id = parameter.id;
				this.form.editlyAddedKey = parameter.npsKey;
				this.checkboxShow = true;
				if(parameter.groupType == 1){
					this.checkParamShow = false;
				}else{
				this.checkParamShow = true;
				}

				}else{
					// 添加
					this.dialogTitle = "添加分组"
					this.dialogFormVisible = true;
					this.form.editlyAddedName = '';
					this.form.groupDesc = '';
					this.form.groupValue = '';
					this.form.id = '';
					this.form.editlyAddedKey = '';
					this.form.enable = 0;
					this.form.cancelEnable = 1;
					this.checkboxShow = false;
					this.checkParamShow = false;
				}
		},

			// 11.9 查询分组
			querygroup(){
				this.form.Groupinglist = [];
				var data = {
				  'terminalId':this.form.terminalId,
				  'pageNo':this.form.pageNo,
				  'pageSize':this.form.pageSize,
				  // 'type':this.form.type,
				  'name':this.form.querySertitleName,
				  'token':this.form.token,
				  'groupValue':this.form.groupValue,
				  'groupDesc':this.form.groupDesc,
				  'key':this.form.editlyAddedKey,
				};
			 api.querygroup(data)
				.then(res => {
					if(res.data.code == 0){
						this.form.Groupinglist = res.data.data.list;
						// this.formStrand.strandlistName = res.data.data.list;
						this.form.totalCount = res.data.data.totalSize;
					}else{
						errorMsg({
							   message: res.data.msg
						})
					}
				})
			},
    copyGroup(){

      this.form.ids = this.handleSelectionChange.map(item => item.id);

      if(this.form.ids.length == 0) {
        errorMsg({
          message: "请选择分组"
        })
        return;
      }
      for(let i=0;i<this.copyGroupData.length;i++){
        let obj = this.copyGroupData[i];
        if(obj.name == this.form.val){
          this.$nextTick(() => {
            this.setCurrent(obj);
          });
        }
      }

      this.dialogCopyGroupVisible = true;
    }
	},
		  created() {
			console.log(this.$route.params.tid)
			this.form.terminalId = this.$route.params.tid;
			this.form.Tval = this.$route.params.Tval;
			// this.form.sval = this.$route.params.Sval;
			// this.form.token = this.$cookies.get('USER_TOKEN_COOKIE');
			this.querygroup();//分组
        this.initCopyGroupData();
	},
	components: {
        Parameter:Parameter,
        SerialNumber:SerialNumber,
        IpComponent:IpComponent,
        Ipv6Component:Ipv6Component,
         NubeComponent:NubeComponent,
        TheGefaultGroup:TheGefaultGroup,
         AppKeyComponent:AppKeyComponent
	}
};
</script>

<style scoped lang="less">
	  .warning-row {
	    background: #f00;
	  }

.terminal {
	.search {
		width: 200px;
		margin-bottom: 10px;
	}
	.topContent{
		color: #00FF00;
	}
	.redrecord{
		color: #f00;
	}
	.crumbs {
		padding: 10px 0px;
	}
	.header {
		margin-bottom: 10px;
		.paging{
			position: absolute;
			right: 10px;
			top: 10px;
		}
	}
}
</style>
